import styled from 'styled-components';
import { breakpoint } from 'styles/globals';

const ArticleGridWrapper = styled.div`
  section {
    display: flex;
    flex-direction: column;
    row-gap: 48px;
    transition: all 0.25s;
    padding: 0px 16px;
    margin-top: 0;
    margin-bottom: 48px;

    @media (${breakpoint.mdMin}) {
      column-gap: 24px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      padding: 0;
      row-gap: 40px;
      .ad-div {
        grid-column: span 2;
      }
    }
    @media (${breakpoint.lgMin}) {
      column-gap: 24px;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      .ad-div {
        grid-column: span 3;
      }
    }
    @media (${breakpoint.xxlMin}) {
      column-gap: 48px;
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    li {
      list-style: none;
    }

    li.nativo-tout--term-archive-1 {
      list-style: none;
      width: 100%;

      a.ntvAdChoicesLink {
        display: none;
        position: absolute;
      }

      a.ntv-headline-anchor {
        margin: 0;
        padding: 0;
        border: 0;
        box-sizing: border-box;
        vertical-align: baseline;
      }
    }
  }
`;

export default ArticleGridWrapper;
